import { Link, useLocation } from "react-router-dom";

const tabs = [
    { path: "/admin/billing/products",     label: "Products" },
    { path: "/admin/billing/plans",        label: "Plans" },
    { path: "/admin/billing/tiers",        label: "Tiers" },
    { path: "/admin/billing/transactions", label: "Transactions" },
    { path: "/admin/billing/payouts",      label: "Payouts" },
    { path: "/admin/billing/settings",     label: "Settings" },
];

export default function BillingTabs() {
    const here = useLocation().pathname;
    return (
        <div className="pxl-affiliate-tabs">
            <ul className="pxl-affiliate-tabs-list">
                {tabs.map(t => (
                    <li
                        key={t.path}
                        className={`pxl-affiliate-tab-item ${here.startsWith(t.path) ? "isActive" : ""}`}
                    >
                        <Link to={t.path}>{t.label}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
